import React, {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import {Box, Button, ButtonGroup, Drawer, Grid, useTheme} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import {useAuth} from "../contexts/AuthContext";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {firestore, storage} from "../firebase";
import {useGroup} from "../contexts/GroupContext";
import AdminGroupSwitchComponent from "./AdminGroupSwitchComponent";
import AddresseeSwitchComponent from "./AddresseeSwitchComponent";
import {withStyles} from "@mui/styles";

export default function PrimarySearchAppBar() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [videoOpen, setVideoOpen] = React.useState(false);
    const [adminOpen, setAdminOpen] = React.useState(false);
    const {setVideoNames, group, role, email} = useGroup()

    const handleOpenVideo = () => {
        setVideoOpen(true);
    };

    const handleCloseVideo = () => {
        setVideoOpen(false);
    };

    const handleOpenAdmin = () => {
        setAdminOpen(true);
    };

    const handleCloseAdmin = () => {
        setAdminOpen(false);
    };

    const handleVideoDialog = () => {
        const name = document.getElementById('videoName').value.trim();

        if (name === "") {
            alert("Please input a name for the video")
            return
        }

        const selectedFile = document.getElementById('videoFile').files[0];

        if (selectedFile === undefined) {
            alert("Please upload a file")
            return
        }
        if (!selectedFile.type.startsWith("video")) {
            alert("Only video files are accepted")
            return
        }
        storage.ref(`/${group}/videos/${name}`).put(selectedFile).then(() => {
            alert("Successfully uploaded video")
            setVideoOpen(false);

            //EW: definitely don't want to do this this way, in time crunch
            //Fetches the list of current videos in the storage bucket for this group
            //TODO: Will: Any subscription like way to make this update dynamically
            //when the user adds a video?
            const storageRef = storage.ref();
            if (group !== undefined) {
                const videosRef = storageRef.child(`${group}/videos`);
                const videos = []
                videosRef.listAll()
                    .then((res) => {
                        res.items.forEach((itemRef) => {
                            videos.push(itemRef.name);
                        });
                        setVideoNames(videos)
                    });
                    }
        }).catch(e => {
            alert("Error uploading video")
        })

        alert("Uploading video in background, this may take a few minutes");
        handleCloseVideo();
    }

    const handleAdminDialog = () => {
        const newEmail = document.getElementById('newEmail').value;
        if (newEmail === "") {
            alert("Please input a valid email.")
            return
        }
        firestore.collection("whitelist").doc(newEmail).set({
            group: group,
            referrer: email
        }).then(() => {
            alert("Successfully referred new user to your group.")
            setAdminOpen(false);
        }).catch(e => {
            alert("Error adding new user")
        })
    }

    const handleLogout = () => {
        toggleDrawer(false)
        logout()
    }

    const toggleDrawer = (b) => {
        setDrawerOpen(b)
    }
    const {currentUser, logout} = useAuth()

    const StyledIconButton = withStyles((theme) => ({
        root: {
            '& svg': {
                color: theme.palette.custom.background,
            }
        },
    }))(IconButton);

    return (
        <Box>
            <AppBar position="fixed">
                <Toolbar>
                    <Grid container>
                        <Grid container item xs={2} justifyContent={'start'}>
                            <StyledIconButton edge="start" onClick={() => toggleDrawer(true)}
                                        aria-label="menu">
                                <MenuIcon fontSize="large"/>
                            </StyledIconButton>
                        </Grid>
                        <Grid item xs>
                            <Box edge="end" mt={1} mb={1} mr={4} display="flex" flexGrow={1} justifyContent="center">
                                <img src="zeeno_dark.svg" height={60} alt={"logo"}/>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <AddresseeSwitchComponent/>
                        </Grid>
                        <Drawer anchor="left" open={drawerOpen} onClose={() => toggleDrawer(false)}>
                            <Box width={300} height="100%" alignContent="stretch" display="flex"
                                 flexDirection="column">
                                <ButtonGroup color="primary" orientation="vertical" variant="text"
                                             size="large"
                                             fullWidth>
                                    <Button className={"menuButton"} size="large" href="/">
                                        HOME
                                    </Button>

                                    <Button className={"menuButton"} size="large" href="/help">
                                        HELP
                                    </Button>

                                    <Button className={"menuButton"} size="large" href="/about">
                                        PRIVACY POLICY
                                    </Button>

                                    {currentUser &&
                                    <Button className={"menuButton"} size="large" onClick={handleOpenVideo}>
                                        UPLOAD VIDEO
                                    </Button>
                                    }

                                    { (role === "admin" || role === "master") &&
                                    <Button className={"menuButton"} sx={{borderBottom: '1px solid #0000003B', borderBottomColor: '#1976D280'}} size="large" onClick={handleOpenAdmin}>
                                        ADD USER
                                    </Button>
                                    }

                                    { (role === "admin") &&
                                    <Button className={"menuButton"} size="large" href="/admin">
                                        ADMIN OPTIONS
                                    </Button>
                                    }

                                    {
                                        (currentUser === null || currentUser === undefined) ?
                                            <Button className={"menuButton"} size="large" href="/login">
                                                LOG IN
                                            </Button>
                                            :
                                            <Button className={"menuButton"}  size="large" onClick={handleLogout}
                                                    href="/login">
                                                LOG OUT
                                            </Button>
                                    }
                                </ButtonGroup>

                                {role === "admin" &&
                                    <AdminGroupSwitchComponent/>
                                }

                            </Box>
                        </Drawer>
                    </Grid>
                    <Dialog open={videoOpen} onClose={handleCloseVideo}>
                        <DialogTitle>Upload Video</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                To upload a video, please enter a video name, select the file, and then press "Upload"
                            </DialogContentText>
                            <TextField autoFocus margin="dense" id="videoName" label="File Name..." fullWidth/>
                            <Box my={2}>
                                <input type="file" id="videoFile" accept="video/*"/>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseVideo} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleVideoDialog} color="primary">
                                Upload
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={adminOpen} onClose={handleCloseAdmin}>
                        <DialogTitle>Add new member</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Please enter the email of the new user.
                            </DialogContentText>
                            <TextField type="email" autoFocus margin="dense" id="newEmail" label="New User's Email..."
                                       fullWidth/>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseAdmin} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleAdminDialog} color="primary">
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
